<template>
    <div v-show="isMenu" :style="style" ref="isMenu">
        <Dropdown trigger ='custom' visible placement="left"  @on-click="setView">
            <DropdownMenu slot="list" ref="widthMenu" >
                <DropdownItem v-for="(item,index) in menuList" :key="item.menuItem" :name="index">{{item.menuItem}}</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>
<script>
export default {
    name : "contextMenu",
    //props : ["primitives","fvSystemApi","parentName"],
    data : function(){
        return {
            isMenu:false,
            style:{},
            menuList:[],
            align:'',
            clientWidth:''
        }
    },
    created : function(){
    },
    mounted : function(){
        //注册contextMenu动态加载组件
        this.$store.registerModule(['system','contextMenu'],{
            state : {
                $ : this
            }
        });
        //鼠标左键点击菜单隐藏
        document.onclick = (e)=>{
            this.isMenu = false;
        }
        //鼠标右键控制  
        // document.oncontextmenu = (e)=> { 
        //     if(!this.$store.state.system.contextMenu.$.isContextmenu){
        //         this.isMenu = false;
        //     }
        //     this.$store.state.system.manager.$.showMenu = true;
        //     return false;
        // }
    },
    methods : {
        //设置右键菜单的点击
        setView(index){
            var targetMenu = this.windowName[index];
            //自定义脚本
            if(targetMenu.action==0){
                if(targetMenu.condition != ""){
                    //执行脚本需要调用executionScript函数来获取当前的this
                    this.fvScript.executionScript(AsyncFunction(targetMenu.condition));
                }
            }
            //打开窗口
            if(targetMenu.action==1){
                this.$store.state.system.manager.$.openView(targetMenu.windowName);
            }
            //关闭窗口
            if(targetMenu.action==2){
                this.$store.state.system.manager.$.closeWindow(targetMenu.windowName);
            }
            //隐藏窗口
            if(targetMenu.action==3){
                this.$store.state.system.manager.$.hideView(targetMenu.windowName);
            }
            //打印窗口
            // if(targetMenu.action==4){
            //     this.$store.state.system.manager.$.toPrintView(targetMenu.windowName);
            // }
            //退出窗口
            if(targetMenu.action==4){
                this.$store.state.system.$.LogOut();
            }
        },
        //show 控制菜单显隐和菜单数据展示
        //params: isShow 控制显隐，style 控制样式，menuList 菜单列表，align 菜单对齐方式
        show : function(event,isShow,style,menuList,align,name){
            this.windowName = name;
            this.menuList = isShow ? menuList : [];
            this.align = isShow ? align : '';
            this.isMenu = isShow ? true : false;
            this.style = isShow ? style : {};
            this.$nextTick(()  => {
                this.clientWidth = this.$refs.widthMenu.$el.clientWidth;
                this.clientHeight = this.$refs.widthMenu.$el.clientHeight;
                //鼠标上方显示
                if(window.innerHeight - event.clientY < this.clientHeight+10){
                     this.$refs.isMenu.style.top = event.clientY - this.clientHeight-24+"px";
                }
                if(this.align == "left"){
                    //鼠标右侧显示
                    if(event.clientX < this.clientWidth){
                        this.$refs.isMenu.style.left = event.clientX+"px";
                    }else if(window.innerWidth - event.clientX < this.clientWidth){
                        this.$refs.isMenu.style.left = window.innerWidth-this.clientWidth+"px";
                    }else{
                        this.$refs.isMenu.style.left = parseInt(this.style.left)-this.clientWidth+"px";
                    }
                }else if(this.align == "center"){
                    if(event.clientX < this.clientWidth/2){
                        this.$refs.isMenu.style.left = event.clientX+"px";
                    }else if(window.innerWidth - event.clientX < this.clientWidth/2){
                        this.$refs.isMenu.style.left = window.innerWidth-this.clientWidth+"px";
                    }else{
                        this.$refs.isMenu.style.left = parseInt(this.style.left)-(this.clientWidth/2)+"px";
                    }
                }else{
                    if(window.innerWidth - event.clientX < this.clientWidth){
                        this.$refs.isMenu.style.left = window.innerWidth-this.clientWidth+"px";
                    }
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/system/contextMenu.vue